import * as moment from 'moment';

moment.locale('nl');

export const formatDate = (string, format) => moment(string).format(format);
export const smallDate = (string) => formatDate(string, 'DD-MM-YYYY LT');
export const bigDate = (string) => formatDate(string, 'LLLL');


// WEBPACK FOOTER //
// ./src/filters/date-filters.js